
import {initWebComponent} from "@/helpers/web-component-helper";
import {resetMap} from "@/helpers/ol/ol-map-helper";

const template = document.createElement('template');
template.innerHTML = `<header-button data-icon="fa fa-home" data-tooltip="openHome"></header-button>`;

export class HeaderHomeComponent extends HTMLElement {
    constructor(){
        super();
        initWebComponent(this, template)

        this.addEventListener('click', () => {
            // resetMap()
            location.reload()
        });
    }
}
